import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=52ee5862&scoped=true&"
import script from "./ScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDetail.vue?vue&type=style&index=0&id=52ee5862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee5862",
  null
  
)

export default component.exports